import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import PositionsList from '../components/PositionsList';
import './Tab2.css';

const Tab2: React.FC = () => {
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Localisation</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">Localisation</IonTitle>
          </IonToolbar>
        </IonHeader>
        <PositionsList />
      </IonContent>
    </IonPage>
  );
};

export default Tab2;
